import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import axios from 'axios'
import { Table, Divider, Button } from 'semantic-ui-react'
import { pythonApiIp, toCurrency } from '../../../../config/constants'
import * as UiConsts from '../../../../config/UiConstants';

class ViewStockPaymentSummary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            stockItemSummary: [],
            vinylSummary: [],
            expenseAccountTotal: 0,
            stockTotalOwed:0,
            vinylTotal:0,
            totalDebt:0
        }
    }

    componentDidMount() {
        console.log("getSum1 ++++++++++ ViewStockPaymentSummary componentDidMount");

        this.getSumStockPaymentsVinlyPayments();

    }


    getSumStockPaymentsVinlyPayments = () => {
        console.log("getSum12 ++++++++:getSumStockPaymentsVinlyPayments");

        this.setState({ loading: true })

        axios.post(pythonApiIp + 'getSumStockPaymentsVinlyPayments', {
            apiKey: "asdfad2244",
            enteredBy: this.props.user.email
        })
            .then((response) => {
                this.setState({ loading: false })
                console.log("getSum13 reply:" + JSON.stringify(response.data, null, 3));

                if (response.data.result) {

                    //stockItemSummary
                    if (response.data.stockItemSummary) {
                        console.log("getSum14 stockItemSummary is there");
                        this.setState({
                            stockItemSummary: response.data.stockItemSummary
                        })
                    } else {
                        console.log("getSum15 can't load stockItemSummary");
                        alert("can't load stockItemSummary")
                    }

                    //vinylSummary
                    if (response.data.vinylSummary) {
                        console.log("getSum16 vinylSummary is there");
                        this.setState({
                            vinylSummary: response.data.vinylSummary
                        })
                    } else {
                        console.log("getSum17 can't load vinylSummary")
                        alert("can't load vinylSummary")
                    }

                    //expenseAccountTotal
                    if (response.data.expenseAccountTotal) {
                        console.log("getSum18 expenseAccountTotal is there");
                        this.setState({
                            expenseAccountTotal: response.data.expenseAccountTotal
                        })
                    } else {
                        console.log("getSum17 can't load vinylSummary")
                        alert("can't load vinylSummary")
                    }

                    this.setState({
                        stockTotalOwed: response.data.stockTotalOwed,
                        vinylTotal: response.data.vinylTotal,
                        totalDebt:response.data.totalDebt
                    })

                } else {
                    console.log("FAILED");
                    alert(response.data.message);
                }
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    loading: false
                })
            });

    }


    render() {

        const vinylItemRows = this.state.vinylSummary.length > 0
        ? this.state.vinylSummary.map((item) =>
            <Table.Row>
                <Table.Cell> {item.item} </Table.Cell>
                <Table.Cell> {toCurrency(item.totalprice__sum)} </Table.Cell>
            </Table.Row>)
        : ''


        const vinylItemTableMain = this.state.vinylSummary.length > 0
            ? <Table celled>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Vinyl Item</Table.HeaderCell>
                        <Table.HeaderCell>Total Owed</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {vinylItemRows}
                </Table.Body>

            </Table>
            :''

        const stockItemRows = this.state.stockItemSummary.length > 0
        ? this.state.stockItemSummary.map((item) =>
            <Table.Row>
                <Table.Cell> {item.shirttypes_sent__shirttype} </Table.Cell>
                <Table.Cell> {toCurrency(item.shirttypes_sent__shirttypebuycost__sum)} </Table.Cell>
            </Table.Row>)
        : ''


        const stockItemTableMain = this.state.stockItemSummary.length > 0
            ? <Table celled>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Item</Table.HeaderCell>
                        <Table.HeaderCell>Total Owed</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {stockItemRows}
                </Table.Body>

            </Table>
            :''
    
        return (
            this.state.loading ? <UiConsts.LoadingComponent /> : <div>
                <h2>STOCK SUMMARY</h2>
                <Button color='blue' onClick={this.getSumStockPaymentsVinlyPayments}>REFRESH</Button>
                <h3>EXPENSE ACCOUNT TOTAL:{toCurrency(this.state.expenseAccountTotal)}</h3>
                <h3> TOTAL DEBT:{toCurrency(this.state.totalDebt)}</h3>

                <Divider horizontal>{'STOCK ITEMS'}</Divider>
                <h4>stockTotalOwed TOTAL:{toCurrency(this.state.stockTotalOwed)}</h4>
                {stockItemTableMain}

                <Divider horizontal>{'VINYL ITEMS'}</Divider>
                <h4>vinylTotal TOTAL:{toCurrency(this.state.vinylTotal)}</h4>
                {vinylItemTableMain}

            </div>
        );
    }
}

export default ViewStockPaymentSummary;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/StockPayment/ViewStockPaymentSummary.js